import {Component, OnDestroy, OnInit} from "@angular/core";
import {GefConnectionDto} from "../../../core/dtos/gef/gef-connection-dto";
import {GefConnectionSavedSupplier, GestionGefService} from "../../../core/services/gef/gestion-gef.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {Subscription} from "rxjs";
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';


@Component({
    selector: 'yo-connections-gef-config',
    templateUrl: './connections-gef-config.component.html',
    styleUrls: ['./connections-gef-config.component.scss'],
    standalone: false
})
export class ConnectionsGefConfigComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  gefConnectionList: GefConnectionDto[] = [];
  selectedConnectionList: GefConnectionDto[] = [];
  subFindAllGefConnections: Subscription;
  subUpdateGefConnection: Subscription;
  subRefreshConnections: Subscription;

  constructor(public gestionGefSvc: GestionGefService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit(): void {
    this.loadGefConnections();
    this.updateGefConnection();
    this.subRefreshConnections = this.gestionGefSvc.refreshGefConnections$.subscribe(() => {
      this.loadGefConnections();
    });
  }

  get canMassEdit(): boolean {
    if (this.selectedConnectionList.length < 2) return false;
    const firstProvider = this.selectedConnectionList[0].gefProvider?.code;
    return this.selectedConnectionList.every(c => c.gefProvider?.code === firstProvider);
  }

  loadGefConnections = (): void => {
    this.utilsSvc.unsubscribe(this.subFindAllGefConnections);
    this.subFindAllGefConnections = this.gestionGefSvc.findAllGefConnections().subscribe(results => {
      this.gefConnectionList = results.resultList;
      this.selectedConnectionList = [];
    });
  };

  updateGefConnection = (): void => {
    this.subUpdateGefConnection = this.gestionGefSvc.gefConnectionSaved$
      .subscribe((response: GefConnectionSavedSupplier) => {
        if (response.isUpdate) {
          const idx: number = this.gefConnectionList.findIndex(connection => connection.id === response.gefConnection.id);
          this.gefConnectionList[idx] = response.gefConnection;
        } else {
          this.gefConnectionList.push(response.gefConnection);
        }
      });
  };

  onSelectionChanged(event: any): void {
    this.selectedConnectionList = event.selectedRowsData;
  }

  openEditConfig(connection: GefConnectionDto) {
    this.gestionGefSvc.announceOpenGefConnectionFluxEditionDialog(connection);
  }

  openDuplicationDialog(connection: GefConnectionDto): void {
    this.gestionGefSvc.announceOpenDuplicationDialog(connection, this.gefConnectionList);
  }

  openModificationMasseDialog(): void {
    this.gestionGefSvc.announceOpenModificationMasseDialog(this.selectedConnectionList);
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subUpdateGefConnection);
    this.utilsSvc.unsubscribe(this.subFindAllGefConnections);
    this.utilsSvc.unsubscribe(this.subRefreshConnections);
  }
}
